var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-date-picker',{staticClass:"subscription-moment",attrs:{"value":_vm.value,"type":"datetime","format":_vm.format,"value-format":_vm.format,"picker-options":_vm.pickerOptions,"placeholder":_vm.$t(_vm.text.pickMoment)},on:{"input":function($event){return _vm.$emit('input', $event)},"change":function($event){return _vm.$emit('change', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }